import { Field, Label, Radio } from "@headlessui/react";
import clsx from "clsx";

interface StyledRadioProps {
  value: string;
  label: string;
  disabled?: boolean;
  checked?: boolean;
}

const StyledRadio = ({ value, label, disabled, checked }: StyledRadioProps) => {
  return (
    <Field key={value} className="flex items-center gap-2 disabled:bg-red-300" disabled={disabled}>
      <Radio
        value={value}
        className={clsx(
          "group flex size-4 items-center justify-center rounded-full border",
          checked ? "bg-blue-600" : "bg-gray-50",
        )}
        disabled={disabled}
      >
        <span
          className={clsx(
            "invisible size-[6px] rounded-full bg-white",
            checked && "visible",
            disabled && "bg-gray-300",
          )}
        />
      </Radio>
      <Label className="">{label}</Label>
    </Field>
  );
};

export default StyledRadio;
